<script lang="ts">
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import type { Snippet } from 'svelte';
	import { getYotpoPreview, type YotpoPreview } from './preview';
	import StarRating from './starRating.svelte';

	interface Props {
		text: Snippet;
		ratedLabel: Snippet;
	}

	let { text, ratedLabel }: Props = $props();

	let preview = $state<YotpoPreview>();
</script>

<div
	class="mx-auto flex max-w-[450px] flex-col items-center gap-y-3 rounded-xl border border-stone-2 px-8 py-5 text-brown-1 lg:max-w-screen-sm"
	use:checkVisibility={{ threshold: 0 }}
	onvisible={async ({ detail }) => {
		if (!detail) return;

		preview = await getYotpoPreview();
	}}
>
	{#if preview}
		<StarRating score={preview.averageScore} starClass="w-6 h-6 lg:w-8 lg:h-8" />
		<div class="text-balance text-center font-serif text-[20px]/[120%] lg:text-[30px]/[130%]">
			{@render text()}
		</div>
		<div class="flex items-center">
			<p class="text-[16px]/[100%] lg:text-[18px]">
				<span class="font-bold">{preview.averageScore}</span> Rated
			</p>
			<div class="mx-2 h-4 w-[0.5px] bg-stone-1"></div>
			{@render ratedLabel()}
		</div>
	{:else}
		<div class="h-8 w-1/2 animate-pulse bg-stone-4"></div>
		<div class="h-9 w-1/3 animate-pulse bg-stone-4"></div>
		<div class="h-6 w-3/5 animate-pulse bg-stone-4"></div>
	{/if}
</div>
